import { render } from "./ModuleMenuV2.vue?vue&type=template&id=21ee828b&scoped=true"
import script from "./ModuleMenuV2.vue?vue&type=script&lang=js"
export * from "./ModuleMenuV2.vue?vue&type=script&lang=js"

import "./ModuleMenuV2.vue?vue&type=style&index=0&id=21ee828b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ee828b"]])

export default __exports__